import axios from "axios";

export const getAuthToken = () => localStorage.getItem("token");

export const authHeaders = (token = getAuthToken()) => ({
  "Content-Type": "application/json; charset=UTF-8",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const authedGet = (url, config = {}) =>
  axios.get(url, {
    ...config,
    headers: {
      ...authHeaders(),
      ...(config.headers || {}),
    },
  });
